import _ from 'lodash';
import React from 'react';
import {getAddressString, getPrimaryImageUrl} from '~/lib/entity';
import {StoreAttributes} from '~/lib/directory';
import StorePreview from '~/modules/widgets/StorePreview';

interface Props {
    store: StoreAttributes;
}

const StorePreviewLink = ({store}: Props) => {
    const {contactInformation, images, name, details} = store;

    const address = getAddressString(contactInformation);
    const primaryImageUrl = getPrimaryImageUrl(images);

    return (
        <StorePreview
            address={address}
            imageUrl={primaryImageUrl}
            name={name}
            sellTreezUrl={details?.sellTreezUrl}
        />
    );
};

export default StorePreviewLink;
